module.exports = __webpack_public_path__ + "img/block-img-1.bbed511f.jpg";